import { api } from 'app/utils/api/helpers'

export const updateUserProfile = (payload: any) => {
  return api.put(`/sm/users/profile`, payload)
}

export const getRegisterUrl = (agencyId: string) => {
  return api.get(`/agency/${agencyId}/registrationurl`)
}

export const getUserPreferenceStatus = (category: string) => {
  return api.get(`/sm/user/alerts/${category}/status`)
}

export const authorizedSubscribe = (category: string) => {
  return api.post(`/sm/user/alerts/subscribe`, {
    unsubscribeCategories: { [category]: true },
  })
}

export const authorizedUnSubscribe = (category: string) => {
  return api.post(`/sm/user/alerts/unsubscribe`, {
    unsubscribeCategories: { [category]: true },
  })
}

type renterProfileRetentionPayload = {
  autoRemovalExtended: boolean
  guid: string
}

export function updateRenterProfile(payload: renterProfileRetentionPayload) {
  return api.put('/sm/renter/profile', payload)
}

export function getRenterProfile() {
  return api.get('/sm/renter/profile')
}
